<template>
	<c-dialog ref="dialog" width="600" @resolve="editHandle">
		<c-form ref="batchStockForm" vertical unit-width="100%">
			<c-form-item label="批次号">
				<c-input name="batch_code" placeholder="请输入，忽略将自动生成"></c-input>
			</c-form-item>
			<c-form-item label="生产日期" required>
				<c-datetime name="production_date" type="datetime" placeholder="请选择生产日期" format="yyyy-MM-dd hh:mm"></c-datetime>
			</c-form-item>
			<c-form-item label="供应商">
				<c-select name="supplier_id" async @search="searchSupplier" :value-data="supplierOptions"></c-select>
				<template #handle>
					<c-link icon v-if="auth('b_supplier_edit')" @click="globalDialog('supplierEdit',{})">创建供应商</c-link>
				</template>
			</c-form-item>
			<c-form-item label="备注">
				<c-input type="textarea" name="remark"></c-input>
			</c-form-item>
			<!--自定义字段-->
			<custom-form ref="customForm" work-type="49"></custom-form>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState} from "vuex";

export default {
	name: 'b_stockbatch_edit',
	computed: {
		// 获取dictName选项数据
		...mapState([]),
	},
	// 监听器
	watch: {
		
	},
	data() {
		return {
			batch_id:0,
			supplierOptions: [],//已选中的供应商信息
		}
	},
	methods: {

		/*********打开编辑框，初始化**********/
		open(data) {
			this._editState = !!data;
			this.$refs.batchStockForm.clear();
			this.$refs.customForm.init();
			if (data) {
				this.$refs.batchStockForm.set(data);
				
				this.batch_id = data.batch_id;
				//查询库存批次详情
				this.request({
					url:'/stock_batch/detail',
					data: {
						batch_id: data.batch_id
					},
					success:data => {
						
						data.detailInfo.production_date = new Date(data.detailInfo.production_date).format('yyyy-MM-dd hh:mm')
						
						this.$refs.batchStockForm.set(data.detailInfo);
						if (data.detailInfo && data.detailInfo.supplier_id && data.detailInfo.supplier_name){
							this.supplierOptions = [{
								name:data.detailInfo.supplier_code +' - ' +data.detailInfo.supplier_name,
								value:data.detailInfo.supplier_id
							}];
						}else {
							this.supplierOptions = [];
						}
					}
				})
			}else{
				this.batch_id = 0;
				//生产日期设置为 今日
				this.$refs.batchStockForm.set({
				    production_date: new Date().format('yyyy-MM-dd hh:mm')
				});
			}
			//填充form表单
			this.$refs.dialog.open({
				title: data ? '编辑库存批次' : '创建库存批次'
			});
		},
		
		/*******搜索【供应商】下拉框信息*****************/
		searchSupplier(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'SUPPLIER',
					keyword: keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},
		
		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.batchStockForm.submit({
				url: this._editState?'/stock_batch/edit':'/stock_batch/add',
				rule: {
					...this.$refs.customForm.rule
				},
				dataFormatter: data => {
					data.batch_id = this.batch_id;
					data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
					return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						message: '提交成功',  // 提示内容,
						type: 'success'
					});
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>
<style lang="stylus" scoped>
</style>